import { Popup3Guard } from './../services/popup3.guard';
import { AddFaqComponent } from './add-faq/add-faq.component';
import { FaqComponent } from './faq/faq.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FormsModule } from '@angular/forms';
import { AuthguardService } from '../config/authguard.service';

const routes: Routes = [
  { path: '', component: FaqComponent,},
  { path: 'faq', component: FaqComponent,},
  { path: 'add-faq', component: AddFaqComponent ,canDeactivate:[Popup3Guard], canActivate: [AuthguardService]},
  { path: 'edit-faq/:id', component: AddFaqComponent,canDeactivate:[Popup3Guard], canActivate: [AuthguardService] },
];

@NgModule({
  declarations: [FaqComponent, AddFaqComponent],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,

    FormsModule,
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule],
})
export class FaqModule {}
